import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import '../../../css/TruckAppointment/AppointmentDetails.css';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import arrowUp from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import calender from '../../../Assets/TruckVisits/Assets-Desktop/calender.svg';
import edit from '../../../Assets/TruckVisits/Assets-Desktop/edit-disable.svg';
import editenable from '../../../Assets/TruckVisits/Assets-Desktop/edit-enable.svg';
import cancelicon from '../../../Assets/TruckVisits/Assets-Desktop/cancel-icon.svg';
import Calendar from 'react-calendar';
import SaveModal from '../../Shared/SaveModal';
import SuccessModal from '../../Shared/SuccessModal';
import 'react-calendar/dist/Calendar.css';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';

import { ApiCall } from '../../../Services/utils/ApiCall';
import { trackingBaseURL } from '../../../Services/config/apiGateway';
import { TRUCK_APPOINTMENT_DETAILS_ENDPOINT } from '../../../Services/config/apiEndPoints';

class AppointmentDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            truckAppoinmentDetails: {},
            gateZone: '',
            lineOperator: '',
            licenseNumber: '',
            referenceNumber: '',
            transactionType: '',
            truckingCompany: '',
            driverLicense: '',
            containerId: '',
            containerEquipmentType: '',
            bookingNumber: '',
            vesselVisit: '',
            terminalName: '',
            requestDate: '',
            appointmentOpeningTime: '',
            modalMessageValue: '',
            SelectTerminal: 'Durban Pier One Container Terminal',
            appointmentvalue: '14:00 - 14:59 (Current Openings: 1)',
            saveReason: "",
            dropdown: false,
            gatedropdown: false,
            transactiondropdown: false,
            containerdropdown: false,
            appointmentdropdown: false,
            lineOperatordropdown: false,
            lineoperatordropdown: false,
            truckingcompanydropdown: false,
            driverlicensedropdown: false,
            containeriddropdown: false,
            isEdit: true,
            terminal: [],
            gate: [],
            transaction: [],
            containerData: [],
            appointment: [],
            lineOperatordata: [],
            lineoperatordata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchlineoperatorlength: 0,
            lineoperatordata1: [],
            truckingcompanydata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchtruckingcompanylength: 0,
            truckingcompanydata1: [],
            driverlicensedata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchedriverlicenselength: 0,
            driverlicensedata1: [],
            containeriddata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchcontaineridlength: 0,
            containeriddata1: [],
            calender: new Date('19-Nov-2020'),
            showCalender: false,
            hasOpenPreview: false,
            hasOpen: false,
            errors: {},
            errormodel: {}
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleChangeLineOperator = this.handleChangeLineOperator.bind(this);
        this.handleChangeTruckingCompany = this.handleChangeTruckingCompany.bind(this);
        this.handleChangeDriverLicense = this.handleChangeDriverLicense.bind(this);
        this.handleChangeContainerID = this.handleChangeContainerID.bind(this);
    }

    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        const { appointmentNumber } = this.props.match.params;
        if (!this.props.history.location.state) {
            ApiCall(
                'GET',
                trackingBaseURL + TRUCK_APPOINTMENT_DETAILS_ENDPOINT + `?user=${'23vkpnadey@gmail.com'}`,

                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',

                },
            ).then((apiData) => {

                if (apiData.flag != -1) {
                    if (apiData.flag == 500) {
                        console.log("in 500");
                        this.setState({ errorMessage: true });
                        this.setState({
                            truckAppointmentDetails: [
                                {
                                    "appointmentNumber": "ABC1233",
                                    "transactionType": "Import",
                                    "slotStart": "1613110942",
                                    "slotEnd": "1613110942",
                                    "status": "Closed",
                                    "gateZone": "A1234",
                                    "lineOperator": "ABC1234",
                                    "licenseNumber": "Shipping lineOperator",
                                    "referenceNumber": "ABC1234",
                                    "truckingCompany": "ABC Truckers",
                                    "driverLicense": "ABC1234",
                                    "containerId": "ABC1234",
                                    "containerEquipmentType": "Reefer Hazard",
                                    "bookingNumber": "ABC1234",
                                    "vesselVisit": "ABC1234"
                                },
                                {
                                    "appointmentNumber": "TCS!@#$",
                                    "transactionType": "Import",
                                    "slotStart": "1613110942",
                                    "slotEnd": "1613110942",
                                    "status": "Closed",
                                    "gateZone": "A1234",
                                    "lineOperator": "ABC1234",
                                    "licenseNumber": "Shipping lineOperator",
                                    "referenceNumber": "ABC1234",
                                    "truckingCompany": "ABC Truckers",
                                    "driverLicense": "ABC1234",
                                    "containerId": "ABC1234",
                                    "containerEquipmentType": "Reefer Hazard",
                                    "bookingNumber": "ABC1234",
                                    "vesselVisit": "ABC1234"
                                },
                                {
                                    "appointmentNumber": "ABC1238",
                                    "transactionType": "Import",
                                    "slotStart": "1613110942",
                                    "slotEnd": "1613110942",
                                    "status": "Closed",
                                    "gateZone": "A1234",
                                    "lineOperator": "ABC1234",
                                    "licenseNumber": "Shipping lineOperator",
                                    "referenceNumber": "ABC1234",
                                    "truckingCompany": "ABC Truckers",
                                    "driverLicense": "ABC1234",
                                    "containerId": "ABC1234",
                                    "containerEquipmentType": "Reefer Hazard",
                                    "bookingNumber": "ABC1234",
                                    "vesselVisit": "ABC1234"
                                },
                                {
                                    "appointmentNumber": "ABC1234",
                                    "transactionType": "Import",
                                    "slotStart": "1613110942",
                                    "slotEnd": "1613110942",
                                    "status": "Closed",
                                    "gateZone": "A1234",
                                    "lineOperator": "ABC1234",
                                    "licenseNumber": "Shipping lineOperator",
                                    "referenceNumber": "ABC1234",
                                    "truckingCompany": "ABC Truckers",
                                    "driverLicense": "ABC1234",
                                    "containerId": "ABC1234",
                                    "containerEquipmentType": "Reefer Hazard",
                                    "bookingNumber": "ABC1234",
                                    "vesselVisit": "ABC1234"
                                },
                                {
                                    "appointmentNumber": "ABC1236",
                                    "transactionType": "Import",
                                    "slotStart": "1613110942",
                                    "slotEnd": "1613110942",
                                    "status": "Closed",
                                    "gateZone": "A1234",
                                    "lineOperator": "ABC1234",
                                    "licenseNumber": "Shipping lineOperator",
                                    "referenceNumber": "ABC1234",
                                    "truckingCompany": "ABC Truckers",
                                    "driverLicense": "ABC1234",
                                    "containerId": "ABC1234",
                                    "containerEquipmentType": "Reefer Hazard",
                                    "bookingNumber": "ABC1234",
                                    "vesselVisit": "ABC1234"
                                },
                                {
                                    "appointmentNumber": "ABC1235",
                                    "transactionType": "Import",
                                    "slotStart": "1613110942",
                                    "slotEnd": "1613110942",
                                    "status": "Closed",
                                    "gateZone": "A1234",
                                    "lineOperator": "ABC1234",
                                    "licenseNumber": "Shipping lineOperator",
                                    "referenceNumber": "ABC1234",
                                    "truckingCompany": "ABC Truckers",
                                    "driverLicense": "ABC1234",
                                    "containerId": "ABC1234",
                                    "containerEquipmentType": "Reefer Hazard",
                                    "bookingNumber": "ABC1234",
                                    "vesselVisit": "ABC1234"
                                },
                                {
                                    "appointmentNumber": "ABC1237",
                                    "transactionType": "Import",
                                    "slotStart": "1613110942",
                                    "slotEnd": "1613110942",
                                    "status": "Closed",
                                    "gateZone": "A1234",
                                    "lineOperator": "ABC1234",
                                    "licenseNumber": "Shipping lineOperator",
                                    "referenceNumber": "ABC1234",
                                    "truckingCompany": "ABC Truckers",
                                    "driverLicense": "ABC1234",
                                    "containerId": "ABC1234",
                                    "containerEquipmentType": "Reefer Hazard",
                                    "bookingNumber": "ABC1234",
                                    "vesselVisit": "ABC1234"
                                },
                            ]
                        });
                    }
                    else {
                        console.log('I am 200!');
                        console.log(apiData);
                        let filteredData = apiData?.filter((name, index) => appointmentNumber == name?.appointmentNumber)
                        console.log("fil====", filteredData);
                        this.setState({
                            truckAppoinmentDetails: filteredData[0],
                            gateZone: filteredData[0]?.gateZone,
                            lineOperator: filteredData[0]?.lineOperator,
                            licenseNumber: filteredData[0]?.licenseNumber,
                            referenceNumber: filteredData[0]?.referenceNumber,
                            transactionType: filteredData[0]?.transactionType,
                            truckingCompany: filteredData[0]?.truckingCompany,
                            driverLicense: filteredData[0]?.driverLicense,
                            containerId: filteredData[0]?.containerId,
                            containerEquipmentType: filteredData[0]?.containerEquipmentType,
                            bookingNumber: filteredData[0]?.bookingNumber,
                            vesselVisit: filteredData[0]?.vesselVisit,
                        })

                    }
                }
            });
        }
        else {
            this.setState({
                truckAppoinmentDetails: this.props.history.location.state,
                gateZone: this.props.history.location.state?.gateZone,
                lineOperator: this.props.history.location.state?.lineOperator,
                licenseNumber: this.props.history.location.state?.licenseNumber,
                referenceNumber: this.props.history.location.state?.referenceNumber,
                transactionType: this.props.history.location.state?.transactionType,
                truckingCompany: this.props.history.location.state?.truckingCompany,
                driverLicense: this.props.history.location.state?.driverLicense,
                containerId: this.props.history.location.state?.containerId,
                containerEquipmentType: this.props.history.location.state?.containerEquipmentType,
                bookingNumber: this.props.history.location.state?.bookingNumber,
                vesselVisit: this.props.history.location.state?.vesselVisit,
            })
        }
    }

    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ dropdown: false });
            this.setState({ gatedropdown: false });
            this.setState({ transactiondropdown: false });
            this.setState({ containerdropdown: false });
            this.setState({ appointmentdropdown: false });
            this.setState({ showCalender: false });
            this.setState({ lineoperatordropdown: false });
            this.setState({ truckingcompanydropdown: false });
            this.setState({ driverlicensedropdown: false });
            this.setState({ containeriddropdown: false });
        }
    };

    terminaldata = [
        { id: 1, terminal: "Cape Town Container Terminal", triptype: "Transhipment" },
        { id: 2, terminal: "Durban Pier One Container Terminal", triptype: "Export" },
        { id: 3, terminal: "Durban Pier One Container Terminal", triptype: "Import" }]

    handleSubmit = () => {
        if (this.handleValidation()) {
            this.setState({ modalMessageValue: ' edited successfully.', hasOpen: true });
        }
    }

    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.lineOperator) {
            formIsValid = false;
            errors["lineOperator"] = Message.validation.required;
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.truckingCompany) {
            formIsValid = false;
            errors["truckingCompany"] = Message.validation.required;
            document.getElementsByName('truckingCompany')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('truckingCompany')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.containerId) {
            formIsValid = false;
            errors["containerID"] = Message.validation.required;
            document.getElementsByName('containerID')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('containerID')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    handleValidationModel() {
        let errormodel = {};
        let formIsValid = true;
        if (this.state.hasOpenPreview == true) {
            if (!this.state.saveReason) {
                formIsValid = false;
                errormodel["enterReason"] = Message.validation.required;
                document.getElementsByName('saveReason')[0].style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementsByName('saveReason')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        this.setState({ errormodel: errormodel });
        return formIsValid;
    }

    terminal = [{ terminalname: "xyz" }, { terminalname: "xyz" }, { terminalname: "xyz" }]
    gate = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    transaction = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    containerData = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    appointment = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    lineOperatordata = [{ name: "dca" }, { name: "abc" }, { name: "bcd" }]

    toggleDropdown = () => {
        this.setState({ dropdown: !this.state.dropdown });
    };

    changeRoleType = (event) => {
        const found = this.terminal?.find((name) => {
            if (name.terminalname === event.target.innerText) {
                return name
            }
        })
        this.setState({ SelectTerminal: found.terminalname });
        this.setState({ dropdown: !this.state.dropdown });
    }

    toggleDropdowngate = () => {
        this.setState({ gatedropdown: !this.state.gatedropdown });
        console.log('vvv')
    };

    changeRoleTypegate = (event) => {
        const found = this.gate?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ gatevalue: found.name });
        this.setState({ gatedropdown: !this.state.gatedropdown });
    }

    toggleDropdowntransaction = () => {
        this.setState({ transactiondropdown: !this.state.transactiondropdown });
        console.log('vvv')
    };

    changeRoleTypetransaction = (event) => {
        const found = this.transaction?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ transactionType: found.name });
        this.setState({ transactiondropdown: !this.state.transactiondropdown });
    }

    toggleDropdowncontainer = () => {
        this.setState({ containerdropdown: !this.state.containerdropdown });
        console.log('vvv')
    };

    changeRoleTypecontainer = (event) => {
        const found = this.containerData?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ containervalue: found.name });
        this.setState({ containerdropdown: !this.state.containerdropdown });
    }

    toggleDropdownappointment = () => {
        this.setState({ appointmentdropdown: !this.state.appointmentdropdown });
        console.log('vvv')
    };

    changeRoleTypeappointment = (event) => {
        const found = this.appointment?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ appointmentvalue: found.name });
        this.setState({ appointmentdropdown: !this.state.appointmentdropdown });
    }

    toggleMonthCalendar = () => {
        this.setState({ showCalender: !this.showCalender });
    }

    handleMonthChanged = (e) => {
        this.setState({
            calender: e
        });
    }

    handleChangeLineOperator = (e) => {
        this.setState({ lineOperator: e.target.value, searchlineoperatorlength: e.target.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                lineOperator: ''
            }
        });
        document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
    }

    handleChangeTruckLicenseNo = (e) => {
        this.setState({ truckLicenseNo: e.target.value });
    }

    handleChangeReferenceNo = (e) => {
        this.setState({ referenceNo: e.target.value });
    }

    handleChangeTruckingCompany = (e) => {
        this.setState({ truckingCompany: e.target.value, searchtruckingcompanylength: e.target.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                truckingCompany: ''
            }
        });
        document.getElementsByName('truckingCompany')[0].style.borderColor = ColorCode.colorCode.black;
    }

    handleChangeDriverLicense = (e) => {
        this.setState({ driverLicense: e.target.value, searchdriverlicenselength: e.target.value?.length });
    }

    handleChangeContainerID = (e) => {
        this.setState({ containerId: e.target.value, searchcontaineridlength: e.target.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                containerId: ''
            }
        });
        document.getElementsByName('containerID')[0].style.borderColor = ColorCode.colorCode.black;
    }

    handleChangeBookingNo = (e) => {
        this.setState({ bookingNo: e.target.value });
    }

    handleChangeVesselVisit = (e) => {
        this.setState({ vesselVisit: e.target.value });
    }

    toggleSearchlineoperatordrop = (e) => {
        this.setState({ lineoperatordropdown: true });
    };

    toggleSearchtruckingcompanydrop = (e) => {
        this.setState({ truckingcompanydropdown: true });
    };

    toggleSearchdriverlicensedrop = (e) => {
        this.setState({ driverlicensedropdown: true });
    };

    toggleSearchcontaineriddrop = (e) => {
        this.setState({ containeriddropdown: true });
    };

    changelineoperator = (event) => {
        const found = this.state.lineoperatordata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ lineOperator: found.name });
        this.setState({ lineoperatordropdown: !this.state.lineoperatordropdown });
    }

    changetruckingcompany = (event) => {
        const found = this.state.truckingcompanydata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ truckingCompany: found.name });
        this.setState({ truckingcompanydropdown: !this.state.truckingcompanydropdown });
    }

    changedriverlicense = (event) => {
        const found = this.state.driverlicensedata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ driverLicense: found.name });
        this.setState({ driverlicensedropdown: !this.state.driverlicensedropdown });
    }

    changecontainerid = (event) => {
        const found = this.state.containeriddata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ containerId: found.name });
        this.setState({ containeriddropdown: !this.state.containeriddropdown });
    }

    onCloseModalPreveiw = () => {
        this.setState({ hasOpenPreview: false });
    }

    onClickModalPreview = () => {
        if (this.handleValidationModel()) {
            this.setState({ hasOpenPreview: false });
            this.setState({ modalMessageValue: ' cancelled successfully.' });
            this.setState({ hasOpen: true });
        }
    }

    handleChangesaveReason = (e) => {
        this.setState({ saveReason: e.target.value });
        this.setState({
            errormodel: {
                ...this.state.errors,
                enterReason: ''
            }
        });
        document.getElementsByName('saveReason')[0].style.borderColor = ColorCode.colorCode.black;
    }

    onSubscribe = () => {
        this.setState({ hasOpenPreview: true });
    }

    onCloseModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/TruckAppointment', {})
    };

    EditValue = () => {
        this.setState({ isEdit: !this.state.isEdit })
    }

    render() {
        if (this.state.searchlineoperatorlength > 0) {
            this.state.lineoperatordata1 = this.state.lineoperatordata?.filter(i => i.name.startsWith(this.state.lineOperator.toLowerCase()))
        } else {
            this.state.lineoperatordata1 = [];
        }
        if (this.state.searchtruckingcompanylength > 0) {
            this.state.truckingcompanydata1 = this.state.truckingcompanydata?.filter(i => i.name.startsWith(this.state.truckingCompany.toLowerCase()))
        } else {
            this.state.truckingcompanydata1 = [];
        }
        if (this.state.searchdriverlicenselength > 0) {
            this.state.driverlicensedata1 = this.state.driverlicensedata?.filter(i => i.name.startsWith(this.state.driverLicense.toLowerCase()))
        } else {
            this.state.driverlicensedata1 = [];
        }
        if (this.state.searchcontaineridlength > 0) {
            this.state.containeriddata1 = this.state.containeriddata?.filter(i => i.name.startsWith(this.state.containerId.toLowerCase()))
        } else {
            this.state.containeriddata1 = [];
        }
        let toggleDropdownImgTransaction = this.state.transactiondropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let toggleDropdownImgAppointmentValue = this.state.appointmentdropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let calendarFormatted_date = this.state.calender.getDate() + "-" + months[this.state.calender.getMonth()] + "-" + this.state.calender.getFullYear();
        if (this.state.calender.getDate() <= 9) {
            calendarFormatted_date = "0" + calendarFormatted_date;
        }
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.appointmentDetailsPageTitle} description={TitleDescription.appointmentDetailsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullAppointDetails">
                    <div id="caacsnobox1ad">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc"> Appointment Details</small>
                            </div>
                            <div id="AppointmentDetailsAcceptMobile" className="AppointmentDetailsNavbarNameRight">
                                <img src={!this.state.isEdit ? edit : editenable} class=" mr-1 pb-1" id="adseditAppointDetailsicon" alt="" loading="lazy" />
                                <a onClick={(this.EditValue)} id={!this.state.isEdit ? "adsh1saveAppointDetails" : "adseditAppointDetails"} class="" >Edit</a>
                                <a onClick={this.onSubscribe}><img src={cancelicon} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                    <small onClick={this.SaveValue} id="adsh1saveAppointDetailsEnable" >Cancel Appointment</small></a>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <>
                            <nav class="AppointmentDetailsMobileNavbar">
                                <div className="AppointmentDetailsNavbarNameRight">
                                    <img src={!this.state.isEdit ? edit : editenable} class=" mr-1 pb-1" id="adseditAppointDetailsicon" alt="" loading="lazy" />
                                    <a onClick={(this.EditValue)} id={!this.state.isEdit ? "adsh1saveAppointDetails" : "adseditAppointDetails"} class="" >Edit</a>
                                    <a onClick={this.onSubscribe}><img src={cancelicon} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                        <small onClick={this.SaveValue} id="adsh1saveAppointDetailsEnable" >Cancel Appointment</small></a>
                                </div>
                            </nav>
                            <hr class="hrADMobile" />
                        </>
                        <div class="caanotificationmaincardad">
                            <div class="caaoncsdivlow1">
                                <div class="adscsdivlow2">
                                    Site Selection</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup2pAppointDetails">
                                    <div class="caadivup3AppointDetails">
                                        <small id="caaname">Terminal</small>
                                        <div className="pass-wrapper" id="topinputboldAppointDetails" >
                                            {this.state.isEdit ?
                                                <small id="caad066enbold">{this.state.SelectTerminal}</small>
                                                :
                                                <small id="caad066eneditbold">{this.state.SelectTerminal}</small>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caaoncsdivlow122AppointDetails">
                                <div class="adscsdivlow2">
                                    Basics</div>
                            </div>
                            {this.state.isEdit ?
                                <div class="caadivup1">
                                    <div class="caadivup4pAppointDetails">
                                        <div class="caadivup55">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Gate / Zone</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.gateZone}</small>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Line Operator</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.lineOperator}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="caadivup5en">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Truck License No. (Optional)</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.licenseNumber}</small>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Reference No. (Optional)</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.referenceNumber}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="caadivup5en">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Transaction Type</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.transactionType}</small>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Trucking Company</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.truckingCompany}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="caadivup5en">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Driver License (Optional)</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.driverLicense}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                <div class="caadivup1">
                                    <div class="caadivup4pAppointDetails">
                                        <div class="caadivup55">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Gate / Zone</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066eneditbold">{this.state.gateZone}</small>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Line Operator</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        name="lineOperator"
                                                        class="input" placeholder="Enter Line Operator"
                                                        type="text" id="caad06" value={(this.state.lineOperator === "NA") ? "" : this.state.lineOperator}
                                                        onChange={this.handleChangeLineOperator}
                                                        onKeyPress={this.toggleSearchlineoperatordrop}
                                                    />
                                                    <div className="appointmentdetailserror11">{this.state.errors["lineOperator"]}</div>
                                                    <img id="caasinput_imgAddProfile" src={search}></img>
                                                </div>
                                                {this.state.lineoperatordropdown && (
                                                    <div class="caaad08" >
                                                        <div class="caadropdowncard" ref={this.container} >
                                                            {(this.state.lineoperatordata1?.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(index1) => this.changelineoperator(index1)}>
                                                                        <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div class="caadivup5">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Truck License No. (Optional)</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        class="input" placeholder="Enter Truck License No."
                                                        type="text" id="caad06" value={(this.state.licenseNumber === "NA") ? "" : this.state.licenseNumber}
                                                        onChange={this.handleChangeTruckLicenseNo}
                                                    />
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Reference No. (Optional)</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        class="input" placeholder="Enter Reference No."
                                                        type="text" id="caad06" value={(this.state.referenceNumber === "NA") ? "" : this.state.referenceNumber}
                                                        onChange={this.handleChangeReferenceNo}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="caadivup5">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Transaction Type</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        readOnly class="input" placeholder="Select Transaction Type"
                                                        type="text" id="caad066" value={this.state.transactionType}
                                                    />
                                                    <i id="caainput_imgAddProfile" onClick={this.toggleDropdowntransaction}>{toggleDropdownImgTransaction}</i>
                                                </div>
                                                {this.state.transactiondropdown && (
                                                    <div class="caaad08" >
                                                        <div class="caadropdowncard" ref={this.container} >
                                                            {(this.transaction?.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(index1) => this.changeRoleTypetransaction(index1)}>
                                                                        <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Trucking Company</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        name="truckingCompany"
                                                        class="input" placeholder="Enter Trucking Company"
                                                        type="text" id="caad06" value={(this.state.truckingCompany === "NA") ? "" : this.state.truckingCompany}
                                                        onChange={this.handleChangeTruckingCompany}
                                                        onKeyPress={this.toggleSearchtruckingcompanydrop}
                                                    />
                                                    <div className="appointmentdetailserror11">{this.state.errors["truckingCompany"]}</div>
                                                    <img id="caasinput_imgAddProfile" src={search}></img>
                                                </div>
                                                {this.state.truckingcompanydropdown && (
                                                    <div class="caaad08" >
                                                        <div class="caadropdowncard" ref={this.container} >
                                                            {(this.state.truckingcompanydata1?.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(index1) => this.changetruckingcompany(index1)}>
                                                                        <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div class="caadivup5">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Driver License (Optional)</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        class="input" placeholder="Enter Driver License"
                                                        type="text" id="caad06" value={(this.state.driverLicense === "NA") ? "" : this.state.driverLicense}
                                                        onChange={this.handleChangeDriverLicense}
                                                        onKeyPress={this.toggleSearchdriverlicensedrop}
                                                    />
                                                    <img id="caasinput_imgAddProfile" src={search}></img>
                                                </div>
                                                {this.state.driverlicensedropdown && (
                                                    <div class="caaad08" >
                                                        <div class="caadropdowncard" ref={this.container} >
                                                            {(this.state.driverlicensedata1?.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(index1) => this.changedriverlicense(index1)}>
                                                                        <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            <div class="caaoncsdivlow122AppointDetails">
                                <div class="adscsdivlow2">
                                    Unit Information</div>
                            </div>
                            {this.state.isEdit ?
                                <div class="caadivup1">
                                    <div class="caadivup4pAppointDetails">
                                        <div class="caadivup55">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Container ID</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.containerId}</small>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Container Equipment Type</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.containerEquipmentType}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="caadivup5en">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Booking No. (Optional in case of import)</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.bookingNumber}</small>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Vessel Visit</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.vesselVisit}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                <div class="caadivup1">
                                    <div class="caadivup4pAppointDetails">
                                        <div class="caadivup55">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Container ID</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        name="containerID"
                                                        class="input" placeholder="Enter Container ID"
                                                        type="text" id="caad06" value={(this.state.containerId === "NA") ? "" : this.state.containerId}
                                                        onChange={this.handleChangeContainerID}
                                                        onKeyPress={this.toggleSearchcontaineriddrop}
                                                    />
                                                    <div className="appointmentdetailserror11">{this.state.errors["containerID"]}</div>
                                                    <img id="caasinput_imgAddProfile" src={search}></img>
                                                </div>
                                                {this.state.containeriddropdown && (
                                                    <div class="caaad08" >
                                                        <div class="caadropdowncard" ref={this.container} >
                                                            {(this.state.containeriddata1?.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(index1) => this.changecontainerid(index1)}>
                                                                        <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Container Equipment Type</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066eneditbold">{this.state.containerEquipmentType}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="caadivup5">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Booking No. (Optional in case of import)</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        class="input" placeholder="Enter Booking No."
                                                        type="text" id="caad06" value={(this.state.bookingNumber === "NA") ? "" : this.state.bookingNumber}
                                                        onChange={this.handleChangeBookingNo}
                                                    />
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Vessel Visit</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066eneditbold">{this.state.vesselVisit}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            <div class="caaoncsdivlow122AppointDetails">
                                <div class="adscsdivlow2">
                                    Appointment Time</div>
                            </div>
                            {this.state.isEdit ?
                                <div class="caadivup1">
                                    <div class="caadivup4pAppointDetails">
                                        <div class="caadivup55">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Requested Date</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{calendarFormatted_date}</small>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Appointment Openings</small>
                                                <div className="pass-wrapper" id="caad07boldAppointDetails" >
                                                    <small id="caad066enbold">{this.state.appointmentvalue}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                <div class="caadivup1">
                                    <div class="caadivup4pAppointDetails">
                                        <div class="caadivup55">
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Requested Date</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        readOnly class="input" placeholder="Select Date"
                                                        type="text" id="caad06" value={calendarFormatted_date}
                                                    />
                                                    <div>
                                                        <div class="AppointmentDateCalender">  {this.state.showCalender ? <div ref={this.container}> <Calendar onChange={this.handleMonthChanged} value={this.calender} /></div> : null}</div>
                                                    </div><img id="caasinput_imgAddProfile" src={calender} onClick={this.toggleMonthCalendar}></img>
                                                </div>
                                            </div>
                                            <div class="caadivup3AppointDetails">
                                                <small id="caaname">Appointment Openings</small>
                                                <div className="pass-wrapper" id="caad07" >
                                                    <Input
                                                        readOnly class="input" placeholder="Select Appointment Openings"
                                                        type="text" id="caad066" value={this.state.appointmentvalue}
                                                    />
                                                    <i id="caainput_imgAddProfile" onClick={this.toggleDropdownappointment}>{toggleDropdownImgAppointmentValue}</i>
                                                </div>
                                                {this.state.appointmentdropdown && (
                                                    <div class="caaad08" >
                                                        <div class="caadropdowncard" ref={this.container} >
                                                            {(this.appointment?.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(index1) => this.changeRoleTypeappointment(index1)}  >
                                                                        <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            {!this.state.isEdit && <div class="caabuttdiv">
                                <Button class="caabuttdiv1AppointDetails" onClick={this.handleSubmit}>
                                    <small class="caabuttdiv2" >Submit</small>
                                </Button>
                            </div>}
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01ad">
                    <Footer />
                </div>
                <div class="caanotifooter02ad">
                    <Footer2 />
                </div>
                <SaveModal hasOpen={this.state.hasOpenPreview} onCloseModal={this.onCloseModalPreveiw} onClickModal={this.onClickModalPreview}>
                    <div className="modalHeadingsave">
                        <p className="modalHeadingTextTruckAppsave">Cancel Transaction Appointment</p>
                    </div>
                    <div className="sectionContainersave">
                        <div className="pass-wrapper" id="caad07savemodal" >
                            <Input
                                name="saveReason"
                                class="input" placeholder="Please enter the reason"
                                type="text" id="caad06savemodal" value={this.state.saveReason}
                                onChange={this.handleChangesaveReason}
                            />
                            <div className="appointmentdetailserror11">{this.state.errormodel["enterReason"]}</div>
                            <img id="caasinput_imgAddProfilesavemodal" src={editenable}></img>
                        </div>
                    </div>
                </SaveModal>
                <SuccessModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successtext1outercreatepreadvisead">
                            <small class="successtext1createpreadvisead">Your appointment has been</small>
                            <small class="successtext1createpreadvisead">{this.state.modalMessageValue} </small>
                        </div>
                    </div>
                </SuccessModal>
            </div>
        );
    }
}

export default AppointmentDetails;